<script setup>
import { HandThumbUpIcon } from '@heroicons/vue/24/outline'

defineProps({
  item: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <a :href="item.url"
     class=" p-5 rounded-lg bg-white hover:bg-gray-100 transition-colors duration-150 ease-in-out border group space-y-2"
  >
    <h2 class="text-indigo-700">{{ item.name }}</h2>
    <span class="text-sm text-gray-500 w-fit">{{ item.category }}</span>
    <div class="flex space-x-2 text-sm text-gray-500 items-center">
      <span>{{ moment(item.posted_at).format('Do MMM YYYY') }}</span>
      <span class="flex items-center gap-1">
          <HandThumbUpIcon class="size-4 inline-block text-gray-500" />
          {{ item.up_votes }}
        </span>
    </div>
  </a>
</template>
